import { render } from "./Widget.vue?vue&type=template&id=0f50c9f8"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=0f50c9f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__